var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_681_48)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.9977 6L14.877 6.4102V18.3121L14.9977 18.4326L20.5223 15.1669L14.9977 6Z",
  fill: "#343434"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9974 6L9.47266 15.1669L14.9974 18.4326V12.6557V6Z",
  fill: "#8C8C8C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9977 19.4788L14.9297 19.5618V23.8014L14.9977 24.0001L20.5257 16.2148L14.9977 19.4788Z",
  fill: "#3C3C3B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9974 24.0001V19.4788L9.47266 16.2148L14.9974 24.0001Z",
  fill: "#8C8C8C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.998 18.4331L20.5227 15.1674L14.998 12.6562V18.4331Z",
  fill: "#141414"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.47266 15.1674L14.9974 18.4331V12.6562L9.47266 15.1674Z",
  fill: "#393939"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_681_48"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white",
  transform: "translate(6 6)"
})));

function SvgIconEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEth);
export default __webpack_public_path__ + "static/media/Icon_ETH.75b6eb9cf39162fa4342b9dbaa9d4aaf.svg";
export { ForwardRef as ReactComponent };